import { Text } from '@simplywallst/ui-core';

import type { Portfolios } from '@/hooks/portfolio/usePortfolio';

import ListItem from '../ListItem';

import { generateName, generateDetails } from '../../utils';

interface Props {
  portfolio: Portfolios[number];
}

export const TransactionPortfolioListItem = ({ portfolio }: Props) => {
  return (
    <ListItem
      key={portfolio.id}
      name={portfolio.id}
      checked={false}
      isUpdating={false}
      title={generateName(portfolio.name, portfolio.currencyISO)}
      details={generateDetails(null, portfolio.holdings.length)}
      disabled
    >
      <Text typography="xSmall" color="black">
        Transaction
      </Text>
    </ListItem>
  );
};
